import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectNetworkErrorMessage } from '../../reducers/networkErrorSlice';
import { useAppSelector } from '../../reducers/rootReducer';
import { addSnackbar } from '../../reducers/snackbarSlice';
import { Nullable } from '../types';

function useErrorStatus() {
  const dispatch = useDispatch();
  const errorMessage = useAppSelector(selectNetworkErrorMessage);
  const [message, setMessage] = useState<
    Nullable<{
      message: string;
      id: string;
    }>
  >(null);

  useEffect(() => {
    const onOnline = () => {
      setMessage(null);
    };
    const onOffline = () => {
      setMessage({
        message: 'Your network connection is lost',
        id: 'network-error',
      });
    };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  useEffect(() => {
    if (errorMessage === 'Network Error') {
      setMessage({
        message: 'Server connection is lost',
        id: 'network-error',
      });
    } else if (errorMessage.indexOf('favourite') !== -1) {
      setMessage({
        message: errorMessage,
        id: 'favourite-error',
      });
    } else {
      setMessage(null);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (message) {
      dispatch(
        addSnackbar({
          snackbar: {
            id: message.id,
            message: message.message,
            type: 'error',
            isOpen: true,
          },
        }),
      );
    }
  }, [message]);
}

export default useErrorStatus;
